module.exports = __webpack_public_path__ + "static/directory_2@2x-fab45be4a5c4af62960d4fe5977605ef.png";